module.exports = __webpack_public_path__ + "static/media/binnen_woonkamer_noord.109c7870.jpg";